import { render, staticRenderFns } from "./entries-list.vue?vue&type=template&id=ed0b2d2c&scoped=true"
import script from "./entries-list.vue?vue&type=script&lang=js"
export * from "./entries-list.vue?vue&type=script&lang=js"
import style0 from "./entries-list.vue?vue&type=style&index=0&id=ed0b2d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0b2d2c",
  null
  
)

export default component.exports